import { useCallback } from "react";
import { useDashboard } from "../context/DashboardContext";
import { Dashboard, DateRange } from "../types";
import { Dealer } from "@/modules/dealer";
export const useDashboardActions = () => {
    const { dispatch } = useDashboard();

    const setCurrentDashboard = useCallback(
        (dashboard: Dashboard | null) => {
            dispatch({ type: "SET_CURRENT_DASHBOARD", payload: dashboard });
        },
        [dispatch]
    );

    const setLoading = useCallback(
        (loading: boolean) => {
            dispatch({ type: "SET_LOADING", payload: loading });
        },
        [dispatch]
    );

    const setError = useCallback(
        (error: string | null) => {
            dispatch({ type: "SET_ERROR", payload: error });
        },
        [dispatch]
    );

    const setSelectedDealer = useCallback(
        (dealer: Dealer | null) => {
            dispatch({ type: "SET_SELECTED_DEALER", payload: dealer });
        },
        [dispatch]
    );

    const setSelectedDateRange = useCallback(
        (dateRange: DateRange | null) => {
            dispatch({ type: "SET_SELECTED_DATE_RANGE", payload: dateRange });
        },
        [dispatch]
    );

    const setSelectedCompareEnabled = useCallback(
        (enabled: boolean) => {
            dispatch({ type: "SET_SELECTED_COMPARE_ENABLED", payload: enabled });
        },
        [dispatch]
    );

    const setSelectedCompareDateRange = useCallback(
        (dateRange: DateRange | null) => {
            dispatch({ type: "SET_SELECTED_COMPARE_DATE_RANGE", payload: dateRange });
        },
        [dispatch]
    );

    const setHydrated = useCallback(
        (hydrated: boolean) => {
            dispatch({ type: "SET_HYDRATED", payload: hydrated });
        },
        [dispatch]
    );

    return {
        setCurrentDashboard,
        setLoading,
        setError,
        setSelectedDealer,
        setSelectedDateRange,
        setSelectedCompareEnabled,
        setSelectedCompareDateRange,
        setHydrated,
    };
};
